import * as Paginator from "react-bootstrap-table2-paginator";

import { Card, Col, Form, Row } from "react-bootstrap";
import React, { useEffect, useRef, useState } from "react";
import ToolkitProvider, {
  CSVExport,
  Search,
} from "react-bootstrap-table2-toolkit";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";
import {
  faCheck,
  faCog,
  faDownload,
  faHome,
  faPlus,
  faSearch,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
import {
  getProductAllExcelDownload,
  getProductEntryByDate,
  getProductEntryExcelDownload,
  getProductEntryPdfDownload,
  getProductPdfDownload,
  getProductAllPdfDownload,
  getProductionList,
  getproductiondsipenserserialNo
} from "../../Service/AllProductionAPI";

import BootstrapTable from "react-bootstrap-table-next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import Table from "react-bootstrap-table-next";
import moment from "moment";
import paginationFactory from "react-bootstrap-table2-paginator";
import swal from "sweetalert";
import ToolTip from "../ToolTip";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

export default () => {
  const { SearchBar } = Search;
  const { ExportCSVButton } = CSVExport;
  const selectRow = {
    mode: "checkbox",
  };
  const [role, setRole] = useState(sessionStorage.getItem("role"));
  const [entries, setEntries] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [shouldRender, setShouldRender] = useState(true);
  const [isLoaded, setisLoaded] = useState(false);
  const [searchDispenserSerialNumber, setSearchDispenserSerialNumber] = useState("");
  const [searchPerformed, setSearchPerformed] = useState(false);
  // ----- pagination
  const [currentPage, setcurrentPage] = useState(0);
  const [pageNo, setPageNo] = useState("");
  const [pageCount, setPageCount] = useState(0);
  const [offset, setOffset] = useState(0);
  const [totaloffset, setTotaloffset] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [numberOfElements, setNumberOfElements] = useState(0);

  useEffect(() => {
    getProduction();
    // eslint-disable-next-line
  }, []);

  const handlePageChange = async (page) => {
    setEntries([]);
    let selectedPage = page - 1;
    if (fromDate === "" && toDate === "") {
      const role = sessionStorage.getItem("role");
      const fkUserId = sessionStorage.getItem("pkUserId");
      const token = sessionStorage.getItem("token");
      const headers = { Authorization: `Bearer ${token}` };
      //   setisLoaded(true);
      await getProductionList(selectedPage, fkUserId, role, headers)
        .then((result) => {
          // console.log("Get Pagination Production Result", result.data);
          if (result?.data?.content?.length !== 0) {
            const data = result.data.content;
            const totalSize = result.data.pageable.offset;
            data.map((item, index) => (item.id = totalSize + index + 1));
            // console.log("totalSize", totalSize);
            // console.log("data", data);
            setEntries(data);
            setTotaloffset(totalSize);
            setPageCount(result.data.totalPages);
            setTotalCount(result.data.totalElements);
            setisLoaded(false);
          } else {
            setisLoaded(false);
            swal("Sorry", "Production data is not present.", "warning");
            setEntries([]);
          }
        })
        .catch((error) => console.error("Error", error));
    }
    // ----- Date wise pagination
    else if (fromDate !== "" && toDate !== "") {
      await getProductEntryByDate(
        selectedPage,
        moment(fromDate).format("yyyy-MM-DD"),
        moment(toDate).format("yyyy-MM-DD")
      )
        .then((result) => {
          // console.log("Get Pagination Date wise Production Result", result);
          if (result?.data?.content?.length !== 0) {
            const data = result.data.content;
            const totalSize = result.data.pageable.offset;
            entries.map((item, index) => (item.id = totalSize + index + 1));
            // console.log("totalSize", totalSize);
            // console.log("data", data);
            setEntries(data);
            setTotaloffset(totalSize);
            setTotalCount(result.data.totalElements);
          } else {
            swal(
              "Sorry",
              "Production data is not present for selected date",
              "warning"
            );
          }
        })
        .catch((error) => {
          console.log("Get Field Issue Error", error);
        });
    } else {
      swal("Failed", "Please select date", "error");
    }
  };

  const getProduction = async () => {
    try {
      // setTimeout(async () => {
      const role = sessionStorage.getItem("role");
      const fkUserId = sessionStorage.getItem("pkUserId");
      const token = sessionStorage.getItem("token");
      const headers = { Authorization: `Bearer ${token}` };
      setisLoaded(true);
      await getProductionList(currentPage, fkUserId, role, headers)
        .then((result) => {
          setisLoaded(false);
          console.log("Get Production Result", result.data);
          if (result?.data?.content?.length !== 0) {
            const data = result.data.content;
            setEntries(data);
            setPageCount(result.data.totalPages);
            setTotalCount(result.data.totalElements);
            setNumberOfElements(result.data.numberOfElements);

          } else {
            setEntries([]);
            setPageCount();
            setTotalCount();
            setisLoaded(false);
            swal("Sorry", "Production data is not present.", "warning");
          }
        })
        .catch((error) => {
          console.log("Get Production Error", error);
        });
      // }, 2000);
    } catch (error) {
      console.log(error);
      swal(
        "Failed",
        "Something went wrong please check your internet",
        "error"
      );
    }
  };

  // const getProductListByFromDate = (e) => {
  //   setFromDate(e.target.value);
  //   console.log(fromDate);
  //   if (e.target.value > new Date().toISOString().split("T")[0]) {
  //     swal("Sorry", "Please select today or day before today", "warning");
  //   }
  // };

  // // ----- Function declaration for setting toDate on "toDate" Product change event
  // const getProductListByToDate = async (e) => {
  //   setToDate(e.target.value);
  //   console.log(toDate);
  //   if (e.target.value > new Date().toISOString().split("T")[0]) {
  //     swal("Sorry", "Please select today or day before today", "warning");
  //   }
  // };


  const handleFromDateChange = (date) => {
    setFromDate(date);
    // Clear the "To" date if it's before the selected "From" date
    if (toDate && date > toDate) {
      setToDate(null);
    }
  };

  const handleToDateChange = (date) => {
    if (date < fromDate) {
      swal('Invalid Date', 'The "To" date cannot be before the "From" date.', 'warning');
      setToDate(null); // Reset "To" date if invalid
    } else {
      setToDate(date);
    }
  };

  const getProductByDate = async () => {
    try {
      setTimeout(async () => {
        // setisLoaded(true);
        if (fromDate !== "" && toDate !== "") {
          await getProductEntryByDate(
            currentPage,
            moment(fromDate).format("yyyy-MM-DD"),
            moment(toDate).format("yyyy-MM-DD")
          )
            .then((result) => {
              console.log("Get Production Entry Result", result);
              if (result?.data?.content?.length !== 0) {
                const data = result.data.content;
                setEntries(data);
                setPageCount(result.data.totalPages);
                setTotalCount(result.data.totalElements);
              

              } else {
                setEntries([]);
                setPageCount();
                setTotalCount();
                swal(
                  "Sorry",
                  "Production data is not present for selected date.",
                  "warning"
                );
              }
              // console.log("setNoOfElements", noOfElements);
            })
            .catch((error) => {
              console.log("Get Production Error", error);
            });
        } else {
          swal("Failed", "Please select date", "error");
        }
        setisLoaded(false);
      }, 200);
    } catch (error) {
      console.log(error);
      swal(
        "Failed",
        "Something went wrong please check your internet",
        "error"
      );
    }
  };



  const getPrductPdfDownload = async () => {
    if (fromDate !== "" && toDate !== "") {
      try {
        await getProductEntryPdfDownload(
          moment(fromDate).format("yyyy-MM-DD"),
          moment(toDate).format("yyyy-MM-DD")
        );
        setisLoaded(false);
        
      } catch (error) {
        console.log("getProductEntryPdfDownload error :-", error);
      }
    } else {
      try {
        await getProductAllPdfDownload();
        setisLoaded(false);
        
      } catch (error) {
        console.log(error);
        swal("Failed", "error");
      }
    }
  };
  

  const getProductExcelDownload = async () => {
    if (fromDate !== "" && toDate !== "") {
      try {
        await getProductEntryExcelDownload(
          moment(fromDate).format("yyyy-MM-DD"),
          moment(toDate).format("yyyy-MM-DD")
        );
       
      } catch (error) {
        console.log("getProductEntryExcelDownload error :-", error);
      }
    } else {
      try {
        await getProductAllExcelDownload();
      } catch (error) {
        console.log(error);
        swal("Failed", "error");
      }
    }
  };

  const clearSearch = () => {
    setSearchDispenserSerialNumber('');
    setSearchPerformed(false);
    getProduction();
  };

  const search = async (e) => {
    console.log("e :-", e);
    setSearchPerformed(true);
    if (!searchDispenserSerialNumber) {
      swal("Missing Serial Number", "Please enter the dispenser serial number", "warning").then(() => {
        clearSearch();
      });
      return; // Exit early if the search input is empty
    }

    try {
      const role = sessionStorage.getItem("role");
      const fkUserId = sessionStorage.getItem("pkUserId");
      const token = sessionStorage.getItem("token");
      const headers = { Authorization: `Bearer ${token}` };
      const result = await getproductiondsipenserserialNo(currentPage, searchDispenserSerialNumber, role, fkUserId, headers);
      // console.log("cheking data ", result?.content)
      // console.log("Searching for Dispenser Serial Number:", searchDispenserSerialNumber);

      if (result?.content?.length > 0) {
        const sortedData = result.content.sort((a, b) => b.pkUserId - a.pkUserId);
        setEntries(sortedData);
        setPageCount(1);
        setTotalCount(sortedData.length);

      } else {
        swal("No Data", "No records found for the given serial number", "info");

        setEntries([]);
      }
    } catch (error) {
      console.error("Search error:", error);
      swal("Failed", "Failed to fetch data, please try again", "error");
    }
  };

  // ----- Adding SrNo column to list
  entries.map((item, index) => (item.id = totaloffset + index + 1));

  // ----- Column heading of Product list
  const columns = [
    { dataField: "id", text: "Id", headerAlign: "left" },
    {
      dataField: "status",
      text: "Production WO Status",
      style: {
        textTransform: "capitalize",
        textAlign:'center'
      },
      editable: false,
    },
    
    {
      dataField: "workOrderNo",
      text: "Production WO No",
      editable: false,
     
    },
    {
      dataField: "generateUniqueDispenserNo",
      text: "Dispenser sr No",
      editable: false, 
     
    },
   
    {
      dataField: "productionDate",
      text: "Wo Created on",
      
      formatter: (cell) => {
        return <>{moment(cell).format("DD-MMM-YYYY")}</>;
      },
      editable: false,
    },
    {
      dataField: "productionTime",
      text: "Wo Created time",
     
      formatter: (cell) => {
        return <>{moment(cell, "hh:mm A").format("hh:mm A")}</>;
      },
      editable: false,
    },
    {
      dataField: "customerName",
      text: "Customer Name",
      editable: false,
     
    },
    {
      dataField: "productType",
      text: "Product Type",
      editable: false,
      
    },
    {
      dataField: "modelName",
      text: "Dispenser Config",
      editable: false,
     
    },
    {
      dataField: "dispenserSrNoAllocationStatusToDevice",
      text: "Dispenser Sr Number status",
      editable: false,
      
    },
    {
      dataField: "whoDidIt",
      text: "Production WO created by ",
      editable: false,
      style: {
        textTransform: "capitalize",
        textAlign:'center'
      },
    },
  ];

  // ----- custom the pagination total
  const customTotal = (from, to, size) => (
    <div>
      Showing {totaloffset + from} to {totaloffset + to} of {size} entries
    </div>
  );

  return (
    <>
      {/* {isLoaded ? (
        <div className="reportload"></div>
      ) : ( */}
        <>
          <Row>
            <Col md={{ span: 3, order: 1 }} className="mb-3" xs={{ order: 2 }}>
              <div className="form-group">
                <label>From Date</label>
                <DatePicker
                  selected={fromDate}
                  onChange={handleFromDateChange}
                  dateFormat="dd-MMM-yyyy"
                  maxDate={new Date()}
                  className="form-control"
                  placeholderText="DD-MMM-YYYY"
                  showYearDropdown
                  scrollableYearDropdown
                />
              </div>
            </Col>
            <Col md={{ span: 3, order: 2 }} className="mb-3" xs={{ order: 3 }}>
              <div className="form-group">
                <label>To Date</label>
                <DatePicker
                  selected={toDate}
                  onChange={handleToDateChange}
                  dateFormat="dd-MMM-yyyy"
                  minDate={fromDate}
                  maxDate={new Date()}
                  className="form-control"
                  placeholderText="DD-MMM-YYYY"
                  showYearDropdown
                  scrollableYearDropdown
                />
              </div>
            </Col>
            <Col md={{ span: 3, order: 3 }} className="mb-3" xs={{ order: 4 }}>
              <button
                className="btn btn-secondary mt-lg-4"
                onClick={getProductByDate}
              >
                <FontAwesomeIcon icon={faSearch} className="me-2" />
                <span>Search By Date</span>{" "}
              </button>
            </Col>
            <Col md={{ span: 3, order: 4 }} className="mt-4" xs={{ order: 1 }}>
              {role === "admin" || role === "back office" ? (
                <>
                  <div className="newadd" align="right">
                    <ToolTip
                      content="Please make sure your RS485 is connected to dispenser"
                      direction="top"
                    >
                      <Link to="add-production" className="btn btn-secondary">
                        <FontAwesomeIcon icon={faPlus} className="me-2" />
                        <span>Create Production Entry</span>{" "}
                      </Link>
                    </ToolTip>
                  </div>
                </>
              ) : (
                " "
              )}
            </Col>
          </Row>
          {/* ----- When you use any toolkit functionalities, you are supposed to render toolkit component and
  BootstrapTable as the children of ToolkitProvider ----- */}
          <ToolkitProvider
            keyField="id"
            search={true}
            columns={columns}
            data={entries}
            // headerClasses="header-class"
            exportCSV={{
              onlyExportFiltered: true,
              exportAll: false,
              fileName: "productionList.csv",
            }}
          >
            {({ baseProps, searchProps, csvProps, props }) => (
              // ----- render the Pagination component as a list with left and right arrows
              <Paginator.PaginationProvider
                pagination={paginationFactory({
                  custom: true,
                  alwaysShowAllBtns: true,
                  totalSize: totalCount,
                  disablePageTitle: true,
                  showTotal: true,
                  paginationTotalRenderer: customTotal,
                  onPageChange: (page) => {
                    handlePageChange(page);
                  },
                })}
              >
                {({ paginationProps, paginationTableProps }) => (
                  <Card>
                    <Col xs={12} md={6} className="p-2">
                      <h5 className="head ">Production Entry list</h5></Col>
                    <div className="table-responsive py-2">
                      <Card.Header>
                        <Row>
                          <Col xs={12} md={6} className="py-1 md-3 d-flex ">

                            <input
                              type="search"
                              placeholder="Search by dispenser Sr No..."
                              value={searchDispenserSerialNumber}
                              onChange={(e) => setSearchDispenserSerialNumber(e.target.value)}
                              className="form-control-alternative form-control searchinput "
                              style={{ marginRight: '10px' }}
                            />

                            <button className="btn btn-secondary" onClick={searchPerformed ? clearSearch : search}>
                              <FontAwesomeIcon icon={searchPerformed ? faTimes : faSearch} className="me-2" />
                              <span>{searchPerformed ? "Clear Serial Number" : "Search By Serial Number"}</span>
                            </button>
                          </Col>

                          <Col
                            xs={12}
                            md={6}
                            className="d-flex justify-content-md-end py-1"
                          >
                            <button
                              className="btn btn-secondary"
                              onClick={getPrductPdfDownload}
                            >
                              <FontAwesomeIcon
                                icon={faDownload}
                                className="me-2"
                              />
                              <span>PDF</span>
                            </button>
                            <button
                              className="btn btn-secondary mx-2"
                              onClick={getProductExcelDownload}
                            >
                              <FontAwesomeIcon
                                icon={faDownload}
                                className="me-2"
                              />
                              <span>Excel</span>{" "}
                            </button>
                          </Col>
                        </Row>
                      </Card.Header>
                       {isLoaded ? (
                              <div className="text-center bg-black text-white"> Please wait production data is loading ... </div>
                            ) : (
                      <BootstrapTable
                        {...baseProps}
                        {...paginationTableProps}
                        bodyClasses="border-0"
                        rowClasses="border-bottom"
                        classes="table-flush dataTable-table"
                        wrapperClasses="table-responsive"
                        headerClasses="header-class"
                        hover
                        striped
                        filter={filterFactory()}
                        remote={{ pagination: true }}
                        cellEdit={cellEditFactory({
                          mode: "click",
                          blurToSave: true,
                          afterSaveCell: (oldValue, newValue, row, column) => {
                            // console.log(oldValue, newValue, row, column);
                          },
                        })}
                      //selectRow={selectRow}
                      />
)}
                      <Card.Footer>
                        <Row>
                          <Col
                            xs={12}
                            md={6}
                            className="d-flex align-items-center py-1"
                          ></Col>
                          <Col
                            xs={12}
                            md={6}
                            className="d-flex justify-content-md-end align-items-center mb-0 py-1"
                          >
                            <Paginator.PaginationListStandalone
                              {...paginationProps}
                            />
                          </Col>
                        </Row>
                      </Card.Footer>
                    </div>
                  </Card>
                )}
              </Paginator.PaginationProvider>
            )}
          </ToolkitProvider>
        </>
      {/* )} */}
    </>
  );
};
